import { postAddressQueryApiV3 } from '@/common/api-for-address';
import { reportCatchError } from '@/utils/reportCatchError';

const ADDRESS_CACHE = 'ADDRESS_CACHE';
const ADDRESS_CACHE_UPDATE_TIME = 'ADDRESS_CACHE_UPDATE_TIME';

// const preQueryV3 = postAddressQueryApiV3(null);

const updateCache = () => {
    return Promise.all([postAddressQueryApiV3(null)])
        .then(newRes => {
            console.log(`[address] initAddressApi result: `, newRes);
            window[ADDRESS_CACHE] = newRes;
            window[ADDRESS_CACHE_UPDATE_TIME] = Date.now();
            return newRes;
        })
        .catch(err => {
            reportCatchError(err, {
                position: 'postAddressQueryApiV3-updateCache',
            });
            return [];
        });
};

const getAPIInfo = async () => {
    console.log('[address] init APIInfo =>', window[ADDRESS_CACHE]);
    const storeCache = window[ADDRESS_CACHE];
    const updateTime = window[ADDRESS_CACHE_UPDATE_TIME];
    let res = [];

    // 使用缓存
    if (storeCache && Array.isArray(storeCache) && storeCache.length) {
        res = storeCache;
    }

    if (!res?.length) {
        return updateCache();
    }

    // 缓存过期时间 3s
    if (!updateTime || Date.now() - updateTime > 3000) {
        updateCache();
    }

    return res;
};

export const getAddressApiRes = getAPIInfo;

export const updateAddressCache = updateCache;
